module.exports = __webpack_public_path__ + "static/media/onDeal.faf9e429.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/common/onDeal.svg
// module id = 461
// module chunks = 2